import getIn from 'transmute/getIn';
import { CONTACTS } from '../constants/KeyPaths';
const getContacts = getIn(CONTACTS);
export default getContacts;